/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import ExternalLink from '../ExternalLink'

import type { FunctionComponent } from 'react'
import type { DocLinkProps } from './types'

import platformVersions from '../../config/platformVersions.json'

const { ecVersion } = platformVersions

const EssHerokuDocLink: FunctionComponent<DocLinkProps> = ({
  href,
  hash,
  showExternalLinkIcon,
  children,
  'aria-label': ariaLabel,
}) => (
  <ExternalLink
    showExternalLinkIcon={showExternalLinkIcon}
    href={getEssHerokuDocLinkUrl({ href, hash })}
    className='docLink'
    aria-label={ariaLabel}
  >
    {children}
  </ExternalLink>
)

function getEssHerokuDocLinkUrl({ href, hash }: Pick<DocLinkProps, 'href' | 'hash'>) {
  const baseUrl = `https://www.elastic.co/guide/en/cloud-heroku/${ecVersion}`

  if (href === `index.html`) {
    return `${baseUrl}/${href}`
  }

  const hashToDisplay = hash != null ? `#ech-${hash}` : ``
  return `${baseUrl}/ech-${href}${hashToDisplay}`
}

export default EssHerokuDocLink
